import React, { useState } from "react";
import { Card } from "@material-tailwind/react";
import toast from "react-hot-toast";

export default function CurrentLocationPopUp({
  closeModal,
  handleSaveLocation,
  city,
  state,
  country,
  address,
  isEditMode,
}) {
  const [formData, setFormData] = useState({
    city: city || "",
    state: state || "",
    country: country || "",
    address: address || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.city || !formData.state || !formData.country) {
      toast.error("Please fill in all required fields");
      return;
    }

    await handleSaveLocation(formData);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-80 z-50">
      <Card
        color="transparent"
        shadow={false}
        className="w-[90%] max-w-[700px] max-h-[90vh] bg-gray-900 rounded-[20px] overflow-hidden flex flex-col"
      >
        <div className="overflow-y-auto flex-1 p-6">
          <form
            onSubmit={handleSubmit}
            className="text-white flex flex-col space-y-6"
          >
            <h2 className="text-xl font-bold mb-4">
              {isEditMode ? "Edit Current Location" : "Add Current Location"}
            </h2>

            {/* City */}
            <div className="relative z-0 w-full group">
              <label htmlFor="city" className="block text-sm">
                City <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="city"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.city}
              />
            </div>

            {/* State */}
            <div className="relative z-0 w-full group">
              <label htmlFor="state" className="block text-sm">
                State/Province <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="state"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.state}
              />
            </div>

            {/* Country */}
            <div className="relative z-0 w-full group">
              <label htmlFor="country" className="block text-sm">
                Country <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="country"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.country}
              />
            </div>

            {/* Address */}
            <div className="relative z-0 w-full group">
              <label htmlFor="address" className="block text-sm">
                Full Address
              </label>
              <textarea
                name="address"
                rows="3"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={handleChange}
                value={formData.address}
              />
              <p className="text-xs text-red-400 mt-1">
                Note: Street address, apartment/suite number, etc.
              </p>
            </div>

            <p className="text-sm text-gray-400">
              <span className="text-red-500">*</span> compulsory fields
            </p>

            <div className="flex items-center justify-between mt-5 space-x-4">
              <button
                type="submit"
                className="w-full px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              >
                {isEditMode ? "Update" : "Save"}
              </button>
              <button
                type="button"
                onClick={closeModal}
                className="w-full px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </Card>
    </div>
  );
}
